import type { ListBuilderList } from '../../../types';
import {
	createAtRiskAvgPerOrderColumn,
	createAtRiskPurchaseInfoColumn,
	createAtRiskQuantitiesColumn,
	createChartColumn,
	createItemColumnWithSuffix,
	createItemNumberColumn,
	createLastPriceColumn,
} from '../columns';

/**
 * At Risk Items list configuration
 * Shows items at risk of being lost based on declining purchase patterns
 */
export const atRiskItemsList: ListBuilderList = {
	id: 'at-risk-items',
	cacheTTL: 600000,
	name: 'At Risk',
	type: 'custom',
	active: true,
	filterRules: {
		viewType: { defaultValue: 'atRisk' },
	},
	columns: [
		createItemColumnWithSuffix('atrisk'),
		createItemNumberColumn(),
		createAtRiskPurchaseInfoColumn(),
		createAtRiskQuantitiesColumn(),
		createLastPriceColumn(),
		createAtRiskAvgPerOrderColumn(),
		createChartColumn('AtRisk'),
	],
	searchEnabled: true,
	searchPlaceholder: 'Search items...',
	sortOrder: 2,
};
